/* global window: true, document: true */
import React from 'react';
import _ from 'lodash';

import './Controls.scss';

class Controls extends React.Component {
    static launchPresentationMode() {
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
        }
    }

    static exitPresentationMode() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozExitFullScreen) {
            document.mozExitFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            showControls: true,
        };

        this.hideControls = _.debounce(this.hideControls, 2000);

        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.startStopFunction = this.startStopFunction.bind(this);
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.handleMouseMove);

        this.hideControls();
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleMouseMove);

        if (this.hideControls) this.hideControls.cancel();
    }

    handleMouseMove(event) {
        if (event.movementY !== 0 && event.movementX !== 0) {
            this.setState({
                showControls: true,
            });

            this.hideControls();
        }
    }

    hideControls() {
        this.setState({
            showControls: false,
        });
    }

    startStopFunction() {
        if (this.props.isPlaying) {
            Controls.exitPresentationMode();
            return this.props.stopSlideshow();
        }
        Controls.launchPresentationMode();
        return this.props.startSlideshow();
    }

    render() {
        const { isPlaying, previousSlide, nextSlide, editCurrentSlide, createWidget } = this.props;

        let startStopText;

        if (isPlaying) {
            startStopText = <i className="fa fa-stop" title="Stop slideshow" />;
        } else {
            startStopText = <i className="fa fa-play" title="Start slideshow" />;
        }

        const classes = ['controls'];

        if (!this.state.showControls) {
            classes.push('slideDown');
        }

        // TODO: Split the seperators into their own divs to have better control of the alignment
        return (
            <div className="controlsContainer">
                <div className={classes.join(' ')} title="Edit slide">
                    {isPlaying === false && <div
                        className="controlButton round"
                        onClick={() => editCurrentSlide()}>
                        <i className="fa fa-cog" />
                    </div>}
                    <div className='playControls round'>
                        <div className="controlButton round-left" onClick={previousSlide} title="Previous slide">
                            <i className="fa fa-step-backward" />
                        </div>
                        <div className="controlButton" onClick={this.startStopFunction} title="Presentation mode">
                            {startStopText}
                        </div>
                        <div className="controlButton round-right" onClick={nextSlide} title="Next slide">
                            <i className="fa fa-step-forward" />
                        </div>
                    </div>
                    {isPlaying === false &&
                        <div
                            className="controlButton round"
                            onClick={createWidget} title="Add widget"
                        >
                            <i className="fa fa-plus" />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

Controls.propTypes = {
    isPlaying: React.PropTypes.bool.isRequired,
    nextSlide: React.PropTypes.func.isRequired,
    previousSlide: React.PropTypes.func.isRequired,
    editCurrentSlide: React.PropTypes.func.isRequired,
    startSlideshow: React.PropTypes.func.isRequired,
    stopSlideshow: React.PropTypes.func.isRequired,
    createWidget: React.PropTypes.func.isRequired,
};

export default Controls;



/** WEBPACK FOOTER **
 ** ./client/components/Controls/Controls.jsx
 **/